import loadable from '@loadable/component';
import { NO_SSR } from 'shared/constants/loadable';

export const NewbuildingsFromDeveloperLoadable = loadable(() => import('./NewbuildingsFromDeveloperContainer'), {
  ssr: NO_SSR,
  resolveComponent: ({ NewbuildingsFromDeveloperContainer }) => NewbuildingsFromDeveloperContainer,
});
